const LoginPage = () => {
    return (
      <div>
        <h3>LoginPage</h3>
      </div>
    );
  };

  export default LoginPage;